<template>
    <div class="search-location" v-loading-bar="isLoading">
        <div v-show="!isLoading && data.length === 0" class="non-tips">
            <i class="iconfont icon-warning"></i>
            {{$t('no_result')}}
        </div>
        <ul>
            <li v-for="(item, i) in data" :key="i" class="city-level">
                <div
                    class="list-item"
                    :class="{'row-hover': item.airport_code}"
                    @click="select(item)"
                >
                    <i
                        class="iconfont"
                        :class="item.airport_code ? 'icon-planeStroke' : 'icon-location'"
                    ></i>
                    <div
                        class="main-text text-ellipsis"
                    >{{item.airport_code ? `${item.airport_name}（${item.airport_code}）` : item.city_name}}</div>
                    <div
                        class="sub-text text-ellipsis"
                    >{{item.airport_code ? item.city_name : ''}}{{item.country_name}}</div>
                </div>
                <ul v-if="item.list && item.list.length > 0">
                    <li v-for="(child, j) in item.list" :key="j" class="airport-level">
                        <div class="list-item" @click="select(child)">
                            <i class="iconfont icon-planeStroke"></i>
                            <div
                                class="main-text text-ellipsis"
                            >{{`${child.airport_name}（${child.airport_code}）`}}</div>
                            <div
                                class="sub-text text-ellipsis"
                            >{{child.city_name}}{{item.country_name ? ',' + item.country_name : ''}}</div>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
import ILoading from "./Loading";
export default {
    name: "searchLocation",
    components: {
        ILoading
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        select(child) {
            if (!child.airport_code) {
                return;
            }
            this.$store.dispatch('setSearchHistory', child)
            this.$emit(
                "menu-select",
                `${child.airport_name}（${child.airport_code}）`,
                child.airport_code
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.search-location {
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 2048;
    width: 456px;
    max-height: 400px;
    min-height: 50px;
    overflow-y: auto;
    padding: 0;
    background-color: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16),
        0px 2px 5px 0px rgba(0, 0, 0, 0.26);

    .non-tips {
        font-size: 14px;
        margin: 0;
        margin-bottom: -10px;
        text-shadow: none;
        font-weight: normal;
        color: #484848;

        i {
            color: #f5c230;
            margin-right: 5px;
        }
    }

    li {
        ul {
            padding-left: 60px;
        }
    }

    .list-item {
        position: relative;
        padding: 10px 40px;
        color: #484848;

        .iconfont {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
        }

        .main-text {
            font-size: 16px;
            line-height: 20px;
        }
        .sub-text {
            font-size: 12px;
            line-height: 16px;
            color: #767676;
        }
    }

    .airport-level {
        margin-left: -60px;

        .list-item {
            padding-left: 60px;
            cursor: pointer;
            .iconfont {
                left: 30px;
            }
        }

        .list-item:hover {
            background-color: RGBA(0, 169, 186, 0.4);
            cursor: pointer;
        }
    }

    .row-hover:hover {
        background-color: RGBA(0, 169, 186, 0.4);
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/AirTicket/components/SearchLocation.vue